import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchData, viewdata, viewattachmentdata, viewdataattach } from './../reduxactions/organizationactions/OrgNeedsViewActions';
import { RootState } from '../reducers';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { GFNButton } from '../ui';

const OrgNeedsView = () => {
    var imageName = require('./../assets/img/g12.png')
    var imageName1 = require('./../assets/img/money.jpg')

    const location = useLocation();
    const [queryParams, setQueryParams] = useState(null);




    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("Id") as any);
    }, [location]);
    const { Id } = useParams();


    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const fetchDataViewAsync = async () => {
        try {
            await dispatch(viewdata(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
        console.log('Id', Id)
    }
    const fetchDataattachViewAsync = async () => {
        try {
            await dispatch(viewattachmentdata(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataViewAsync();
        fetchDataattachViewAsync();
    }, [dispatch])

    const data = useSelector((state: RootState) => state.orgneedsview.data);
    const dataview = useSelector((state: RootState) => state.orgneedsview.dataview);
    const attachdataview = useSelector((state: RootState) => state.orgneedsview.attachdataview);
    const attachdata = useSelector((state: RootState) => state.orgneedsview.attachdata);


    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const [assignData, setassignData] = useState({
        Id: '',
    });
    const viewupload = (item: any) => {
        setassignData({
            Id: item.Id,

        });

        setfield(true);
        fetchDataAsyncdialog();
    };
    const fetchDataAsyncdialog = async () => {
        try {
            const { Id } = assignData;
            console.log("ids", Id)
            dispatch(viewdataattach(uid, Id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-viewneeds.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Organization Details</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <section className="content">
                            {data.map((response: any, index: number) => (
                                <div className="grid" key={index}>
                                    {/* LEFT PROFILE SECTION */}
                                    <div className="col-12 lg:col-3">
                                        {/* Profile Card */}
                                        <Card className="shadow-4 border-round-3xl overflow-hidden">

                                            {/* Banner */}
                                            <div
                                                className="border-round-top-3xl"
                                                style={{
                                                    height: "120px",
                                                    background: "linear-gradient(135deg,#2563eb,#60a5fa)"
                                                }}
                                            ></div>

                                            {/* Profile Image */}
                                            <div className="flex justify-content-center">
                                                <img
                                                    src={response.profilepic}
                                                    alt="Profile"
                                                    style={{
                                                        width: "130px",
                                                        height: "130px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                        marginTop: "-65px",
                                                        border: "5px solid white"
                                                    }}
                                                />
                                            </div>

                                            {/* Organization Info */}
                                            <div className="text-center mt-3">
                                                <h2 className="m-0 text-900">
                                                    {response.nameoftheorg}
                                                </h2>

                                                <p className="text-600 mt-2">
                                                    {response.designation}
                                                </p>
                                            </div>

                                            <div className="mt-4">

                                                <div className="flex justify-content-between mb-3">
                                                    <span className="font-semibold text-700">
                                                        Organization Head
                                                    </span>

                                                    <span className="text-600">
                                                        {response.nameofthehead}
                                                    </span>
                                                </div>

                                                <div className="flex justify-content-between mb-3">
                                                    <span className="font-semibold text-700">
                                                        License No
                                                    </span>

                                                    <span className="text-600">
                                                        {response.licenseno}
                                                    </span>
                                                </div>

                                                <div className="flex justify-content-between mb-3">
                                                    <span className="font-semibold text-700">
                                                        Expiry Date
                                                    </span>

                                                    <span className="text-600">
                                                        {response.license_expdate}
                                                    </span>
                                                </div>

                                                <div className="flex justify-content-between mb-3">
                                                    <span className="font-semibold text-700">
                                                        Contact
                                                    </span>

                                                    <span className="text-600">
                                                        {response.mobile}
                                                    </span>
                                                </div>

                                                <div className="flex justify-content-between mb-3">
                                                    <span className="font-semibold text-700">
                                                        Email
                                                    </span>

                                                    <span className="text-600">
                                                        {response.email}
                                                    </span>
                                                </div>

                                                <div className="flex justify-content-between">
                                                    <span className="font-semibold text-700">
                                                        Location
                                                    </span>

                                                    <span className="text-600">
                                                        {response.address}
                                                    </span>
                                                </div>

                                            </div>

                                        </Card>
                                    </div>
                                    {/* RIGHT CONTENT SECTION */}
                                    <div className="col-12 lg:col-9">
                                        {/* Need Details */}
                                        <Card className="shadow-3 border-round-2xl mb-4">
                                            <div className="flex align-items-center mb-4">
                                                <i className="pi pi-briefcase text-3xl text-blue-500 mr-3"></i>
                                                <div>
                                                    <h2 className="m-0 text-900">
                                                        {response.needtittle}
                                                    </h2>
                                                    <span className="text-600">
                                                        {response.needtype}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="grid">
                                                {/* Planned Budget */}
                                                <div className="col-12 md:col-6">
                                                    <div
                                                        className="p-4 border-round-2xl shadow-2"
                                                        style={{
                                                            background: "#eff6ff"
                                                        }}
                                                    >
                                                        <div className="flex align-items-center justify-content-between">
                                                            <div>
                                                                <p className="m-0 text-600">
                                                                    Planned Budget
                                                                </p>

                                                                <h2 className="mt-2 text-blue-700">
                                                                    ₹ {response.budget_amount}
                                                                </h2>
                                                            </div>
                                                            <i className="pi pi-wallet text-4xl text-blue-400"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Received Amount */}
                                                <div className="col-12 md:col-6">
                                                    <div
                                                        className="p-4 border-round-2xl shadow-2"
                                                        style={{
                                                            background: "#ecfdf5"
                                                        }}
                                                    >
                                                        <div className="flex align-items-center justify-content-between">
                                                            <div>
                                                                <p className="m-0 text-600">
                                                                    Received Amount
                                                                </p>
                                                                <h2 className="mt-2 text-green-600">
                                                                    ₹ {response.received_amount}
                                                                </h2>
                                                            </div>
                                                            <i className="pi pi-money-bill text-4xl text-green-400"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                        {/* Donations */}
                                        <Card className="shadow-3 border-round-2xl mb-4">
                                            <div className="card flex flex-wrap justify-content-end my-2">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search ml-2" />
                                                    <InputText
                                                        className="app-search-input"
                                                        value={globalFilter}
                                                        onChange={(e) => setGlobalFilter(e.target.value)}
                                                        placeholder="Global Search"
                                                    />
                                                </span>
                                            </div>
                                            <DataTable
                                                value={dataview}
                                                paginator
                                                rows={5}
                                                stripedRows
                                                responsiveLayout="scroll"
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                globalFilter={globalFilter}
                                            >
                                                <Column
                                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                                    header="S.No"
                                                />

                                                <Column
                                                    field="donor_name"
                                                    sortable
                                                    header="Donor Name"
                                                />
                                                <Column
                                                    field="cdate"
                                                    sortable
                                                    header="Date"
                                                />
                                                <Column
                                                    field="budget_amount"
                                                    sortable
                                                    header="Amount"
                                                />
                                            </DataTable>
                                        </Card>
                                        {/* Description */}
                                        <Card className="shadow-3 border-round-2xl mb-4">
                                            <div className="flex align-items-center mb-3">
                                                <i className="pi pi-file-edit text-2xl text-blue-500 mr-2"></i>
                                                <h3 className="m-0">
                                                    Need Description
                                                </h3>
                                            </div>
                                            <InputTextarea
                                                autoResize
                                                value={response.description}
                                                disabled
                                                rows={6}
                                                className="w-full"
                                            />
                                        </Card>
                                        {/* Attachments */}
                                        <Card className="shadow-3 border-round-2xl">
                                            <div className="flex align-items-center mb-4">
                                                <i className="pi pi-images text-2xl text-blue-500 mr-2"></i>

                                                <h3 className="m-0">
                                                    Related Attachments
                                                </h3>
                                            </div>
                                            <div className="grid">
                                                {attachdataview.map((item: any, i: number) => (
                                                    <div className="col-12 md:col-4" key={i}>
                                                        <div className="border-1 border-300 border-round-2xl p-3 text-center shadow-1">
                                                            <img
                                                                src={item.path}
                                                                alt="attachment"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "180px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "12px"
                                                                }}
                                                            />
                                                            <h5 className="mt-3 mb-2">
                                                                {item.vdate}
                                                            </h5>
                                                            <Button
                                                                className="w-full"
                                                                severity="info"
                                                                icon="pi pi-eye"
                                                                label="View"
                                                                onClick={() => viewupload(item)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            ))}
                        </section>
                        <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <DataTable value={attachdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                <Column header="Donor Name" body={(rowData) => (
                                    <span>{rowData.addressofuser}</span>
                                )}></Column>
                            </DataTable>
                            {/* <Button label="Close" onClick={cancelfield} className="mr-3 p-button-secondary" /> */}
                            <GFNButton label="Close" onClick={cancelfield} buttonType="secondary" />
                        </Dialog>
                    </div >
                </div>
            </div>
        </div>
    )
}

export default OrgNeedsView
